/**
 * 错误提示组件
 */
import React from 'react';

const ErrorAlert = ({ message, onClose }) => {
  if (!message) return null;
  
  return (
    <div className="error-alert">
      <span className="error-alert-icon">⚠️</span>
      <span className="error-alert-text">{message}</span>
      {onClose && (
        <button className="error-alert-close" onClick={onClose}>×</button>
      )}
    </div>
  );
};

export default ErrorAlert;
